module.exports = __webpack_public_path__ + "img/log.944f42a3.svg";